import { environment } from './../../../environments/environment';
import { AuthService } from './../../shared/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';

@Component({
  selector: 'app-dev-login',
  templateUrl: './dev-login.component.html',
  styleUrls: ['./dev-login.component.scss']
})
export class DevLoginComponent implements OnInit {
  users: UserLogin[];

  constructor(
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.users = environment.users;
    this.breadcrumbService.setBreadcrumb(this.activatedRoute);
  }

  login(cfid: string) {
    this.authService.clearUserFromLocalStorage();
    this.authService.login(cfid);
  }
}

interface UserLogin {
  name: string;
  cfid: string;
}
